import React, {useState} from 'react'

export default function TemperatureConversion() {
    const [tempDC, setTempDC] = useState(0)
    const [tempFH, setTempFH] = useState(0)
    const [tempK, setTempK] = useState(0)


    /**Disabling the mouse wheel */
    const inputFields = document.querySelectorAll('.highlight');
    inputFields.forEach(function(inputField) {
            inputField.addEventListener('wheel', function(event) {
            event.preventDefault();
        });
    })
    
  return (
    <div>
      <div>
        <div style={{display:"flex", justifyContent:"center"}}>
        <h2 style={{color:"#F9D081"}}>Temperature Conversions</h2>
        </div>
            
        <div   className="grid-container" style={{backgroundColor:"#o44f44d", marginLeft:"25%", marginRight:"25%"}}>
            <div  >
                <div><label id="myLabels" htmlFor="number">Celsius (<sup>o</sup>C)</label></div>
                
                <input className="highlight" type="number" 
                value={tempDC}
                onChange={(e) => {
                const fh = parseFloat((e.target.value * 1.8) + 32);
                const k = parseFloat(e.target.value) + 273.15;
                setTempDC(e.target.value)
                setTempFH(fh)
                setTempK(k)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Fahrenheit (<sup>o</sup>F)</label></div>
                <input className="highlight" type="number"
                value={tempFH}
                onChange={(e) => {
                const dc = ((parseFloat(e.target.value)-32)*5)/9;
                const k = (((parseFloat(e.target.value)-32)*5)/9)+273;
                setTempFH(parseFloat(e.target.value))
                setTempDC(dc)
                setTempK(k)
            }}/></div>


<div  >
                <div><label id="myLabels" htmlFor="number">Kelvin (K)</label></div>
                
                <input className="highlight" type="number" 
                value={tempK}
                onChange={(e) => {
                const dc = parseFloat(e.target.value) - 273.15;
                const fh = ((parseFloat(e.target.value) - 273.5) * 1.8 ) + 32
                setTempDC(dc)
                setTempFH(fh)
                setTempK(parseFloat(e.target.value))
            }}/></div>

        

        </div>

    
        </div> 
<div style={{display:"flex", justifyContent:"center"}}>
<button className='clear-button' onClick={(e) => {
        setTempDC(0)
        setTempFH(0)
        setTempK(0)
    }}>
        Clear Button
    </button>
</div>

    </div>
  )
}
